export const API_BASE_URL = import.meta.env?.VITE_API_URL || 'https://76keeilte5.execute-api.us-east-2.amazonaws.com';

export const ADMIN_API_BASE = API_BASE_URL;
